// Basic imports
import { createApp } from "vue";
import { createPinia } from "pinia";
import TheApp from "@/App.vue";
import { router } from "@/router";

// Plugins
import "@/plugins/dayjs";

// Tooltips
import FloatingVue from "floating-vue";

import "@/scss/properties.scss";
import "@/scss/general/general.scss";

// Element plus
import { ElLoading } from "element-plus";

// 3rd party logins
import vue3GoogleLogin from "vue3-google-login";

// Translations
import { gettext } from "@/services/translation";

// Error tracking
import { captureException } from "@/services/analytics/sentry";

// HTML <head> tag
import { createHead } from "@unhead/vue/client";

// Custom directives
import errorShake from "@/directives/errorShake";
import animatePop from "@/directives/animatePop";

// Onload animations (and more)
import { MotionPlugin } from "@vueuse/motion";

// @nuxt-rework: move to a client-only Nuxt plugin (plugins/app-version.client.ts)
window.appVersion = import.meta.env.VITE_APP_VERSION; // Sentry (in GTM) uses this information.

const app = createApp(TheApp);
app.use(createPinia());
app.use(gettext);
app.use(createHead());
app.use(vue3GoogleLogin, { clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID });
app.use(router);
app.use(FloatingVue);
app.use(MotionPlugin);

app.directive("loading", ElLoading.directive);
app.directive("error-shake", errorShake);
app.directive("animate-pop", animatePop);

app.config.errorHandler = (err, _instance, info) => {
  captureException(err);
  console.error("[Vue]", info, err);
};

window.addEventListener("unhandledrejection", (event) => {
  captureException(event.reason);
});

app.mount("#app");
